var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[(_vm.workspaceLoading)?_c('AppWait',[_vm._v(" App start is in progress. Please wait... ")]):_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }